import React, { Component } from 'react'
import { PRIMARY_COLOR } from '../consts/index'

/**
 *
 * @param {confirm} : show confirm
 * @param {addIcon} : show addIcon
 * @param {downloadIcon} : show downloadIcon
 */
function CustomButton({
  title,
  onClick,
  confirm,
  addIcon,
  downloadIcon,
  editIcon,
  width,
  style
}) {
  return (
    <button
      style={{
        backgroundColor: confirm ? PRIMARY_COLOR : '#fff',
        color: confirm ? '#fff' : PRIMARY_COLOR,
        width: width || 140,
        height: 40,
        border: '1px solid ' + PRIMARY_COLOR,
        outline: 'none',
        borderRadius: 5,
        ...style
      }}
      onClick={() => onClick()}
    >
      {addIcon && <i className='fa fa-plus' />}{' '}
      {downloadIcon && <i className='fa fa-download' />} {title}
      {editIcon && <i className='fa fa-edit' />}
    </button>
  )
}

export default CustomButton
